import { registerComponent } from '../app'
import Browser from '../services/Browser'
import { WINDOW_RESIZE, ORIENTATION_CHANGE } from '../events'

const InnerWindowHeight = (scope, el) => {
	const setSize = () => {
		el.style.height = window.innerHeight + 'px'
	}

	const init = () => {
		if (!Browser.isIOS()) {
			scope.on(WINDOW_RESIZE, () => setTimeout(setSize, 250))
		}
		scope.on(ORIENTATION_CHANGE, () => setTimeout(setSize, 250))

		setSize()
	}

	scope.start(() => init())
}

registerComponent('inner-window-height', InnerWindowHeight)
